/* eslint-disable import/prefer-default-export */
export const SET_CURRENT_API_ID = 'SET_CURRENT_API_ID';
export const SET_RECORD_TO_LOAD = 'SET_RECORD_TO_LOAD';
export const RESET_RECORD_TO_LOAD = 'RESET_RECORD_TO_LOAD';
